import { useCallback, useState } from 'react';
import { useSWRFetch } from '@hooks/useSWRFetch';
import { Request } from '@hooks/useSWRFetch/types';
import { TEN_MINUTES_IN_MS } from '@helpers/constants';
import { buildAlbumUriFromId, isEmptyString } from '@helpers/utils';
import { DeliveryXmlResponse } from './types';

export const useProductXml = (
  albumUriId = '',
  feedGid = '',
  deliveryId = '',
  productId = '',
) => {
  const [deliveryIdToSearch, setDeliveryIdToSearch] = useState<string>('');

  const encodedProductId = encodeURIComponent(productId);
  const encodedDeliveryId = encodeURIComponent(deliveryId);
  const searchParams = new URLSearchParams();

  searchParams.append('albumUri', buildAlbumUriFromId(albumUriId));
  searchParams.append('feedGid', feedGid);
  searchParams.append('deliveryId', encodedDeliveryId);
  searchParams.append('productId', encodedProductId);

  const requestObject: Request = {
    url: `catalog/api/productxml?${new URLSearchParams(searchParams)}`,
    baseUrl: '',
  };

  const canRequest =
    !isEmptyString(deliveryIdToSearch) &&
    !isEmptyString(albumUriId) &&
    !isEmptyString(feedGid) &&
    !isEmptyString(deliveryId) &&
    !isEmptyString(productId);

  const { data, isValidating, error, status, mutate } =
    useSWRFetch<DeliveryXmlResponse>(canRequest ? requestObject : null, {
      dedupingInterval: TEN_MINUTES_IN_MS,
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    });

  const getXmlData = useCallback((newId: string) => {
    setDeliveryIdToSearch(newId);
  }, []);

  return { data, isValidating, error, status, actions: { getXmlData }, mutate };
};
